<template>
<section class="content close-date-picker primary_pending_wrp" style="position:relative;">
    <div class="box-body">
        <div class="main_select_wrp_relative">

            <div class="modal fade model_modify_wrp" id="filtertoogle" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog" role="document" style="width: 50%">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h2>Filters</h2>
                            <button type="button" class="close clearButton" data-dismiss="modal" v-on:click="clearFilter">Clear All</button>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="main_select_wrp">
                                <div class="flex selectwca_wrp" v-if="this.adminCheck =='superAdmin'">
                                    <!-- <div class="multiselected">
                                        <label>Select City</label>
                                        <multiselect track-by="value" v-model="filters.city.value" label="name" placeholder="Select City" :options="cityList" name="city" selectLabel="" deselectLabel="" selectedLabel="" @select="onCheckedCity" @remove="onRemoveCity"></multiselect>
                                    </div> -->
                                    <div class="multiselected">
                                        <label>Zone</label>
                                        <multiselect track-by="value" v-model="filters.startLocation.value" label="name" placeholder="Zone" :options="startLocationList" multiple name="startLocation" selectLabel="" deselectLabel="" selectedLabel="" @select="getStartLocation" @remove="onRemoveSL">
                                            <span style="display:block" slot="noResult">Oops! No elements found</span>
                                        </multiselect>
                                    </div>
                                    <div class="multiselected">
                                        <label>Status</label>
                                        <multiselect track-by="value" v-model="filters.status.value" label="name" placeholder="Select Status" :options="status" multiple name="status" selectLabel="" deselectLabel="" selectedLabel="" @select="onCheckedStatus" @remove="onRemoveStatus"></multiselect>
                                    </div>
                                    
                                    <!-- <div class="multiselected">
                                        <label>End location</label>
                                        <multiselect track-by="_id" v-model="filters.endLocation._id" label="name" placeholder="End location" :options="endLocationList" multiple name="endLocation" selectLabel="" deselectLabel="" selectedLabel="" @select="getEndLocation" @remove="onRemoveEL"></multiselect>
                                    </div> -->
                                </div>
                                <div class="flex selectwca_wrp" v-if="this.adminCheck !=='superAdmin'">

                                    <div class="multiselected">
                                        <label>Zone</label>
                                        <multiselect track-by="value" v-model="filters.startLocation.value" label="name" placeholder="Zone" :options="startLocationList" multiple name="startLocation" selectLabel="" deselectLabel="" selectedLabel="" @select="getStartLocation" @remove="onRemoveSL">
                                            <span style="display:block" slot="noResult">Oops! No elements found</span>
                                        </multiselect>
                                    </div>
                                    <!-- <div class="multiselected">
                                        <label>End location</label>
                                        <multiselect track-by="_id" v-model="filters.endLocation._id" label="name" placeholder="End location" :options="endLocationList" multiple name="endLocation" selectLabel="" deselectLabel="" selectedLabel="" @select="getEndLocation" @remove="onRemoveEL"></multiselect>
                                    </div> -->
                                    <div class="multiselected">
                                        <label>Status</label>
                                        <multiselect track-by="value" v-model="filters.status.value" label="name" placeholder="Select Status" :options="status" multiple name="status" selectLabel="" deselectLabel="" selectedLabel="" @select="onCheckedStatus" @remove="onRemoveStatus"></multiselect>
                                    </div>                                    
                                </div>
                            </div>
                            <div class="select_date_wrp">

                                <div class="datedrop_boxs_wrp">

                                    <div class="datedrop_boxs selectwca_wrp">
                                        <div class="dates_left">
                                            <label>Select Driver</label>
                                            <multiselect track-by="value" v-model="filters.driver.value" label="name" placeholder="Select Driver" :options="driver_name" :key="driver_name.length" name="driver" selectLabel="" deselectLabel="" selectedLabel="" @select="onCheckedDriver" @remove="onRemoveDriver"></multiselect>
                                        </div>
                                        <div class="dates_left">
                                            <label>Start Date</label>
                                            <date-picker @change="startDate()" id="startDate" v-model="date.startDate" lang="en" name="startDate" required input-class="form-control" width="100%" valueType="format" :format="'DD-MM-YYYY'" placeholder="Start date"></date-picker>
                                        </div>
                                        <div class="dates_left">
                                            <label>End Date</label>
                                            <date-picker :disabled="!date.startDate" @change="endDate()" @input="dateValidationClear" :not-before="startDateIso" id="endDate" v-model="date.endDate" lang="en" name="endDate" required input-class="form-control" width="100%" valueType="format" :format="'DD-MM-YYYY'" placeholder="End date"></date-picker>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div :class="addButtonClass" class="primary_trip_res">
            <div class="filter_wrpp">
                <button type="button" class="btn gradientbt" data-toggle="modal" data-target="#filtertoogle">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:cc="http://creativecommons.org/ns#" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#">
                        <g transform="translate(0 -1028.4)">
                            <path d="m10 11v10l4 3v-13h-4z" fill="#fff" transform="translate(0 1028.4)" />
                            <path d="m10 11v10l2 1.5v-11.5h-2z" fill="#fff" transform="translate(0 1028.4)" />
                            <path d="m1 1028.4 9 11h4l9-11z" fill="#fff" />
                            <path d="m1 1028.4 9 11h2v-11z" fill="#fff" />
                        </g>
                    </svg>
                    Apply Filter
                    <span :class="{'counter_filter' : count }">{{ count }}</span>
                </button>
            </div>

            <router-link :to="{ name: 'addPrimaryTrip', params: { _id: '0' } }">
                <button class=" btn gradientbt">Add Primary Trip</button>
            </router-link>
        </div>
        <v-server-table ref="primaryTripTable" url :limit="5" :columns="columns" :options="options" @loaded="onLoaded">
            <template slot="beforeBody">
                <tr v-if="loading" class="VueTables__no-results">
                    <td class="text-center" colspan="9">
                        <pulse-loader></pulse-loader>
                    </td>
                </tr>
            </template>
            <template slot="status" slot-scope="props">
                <div :class= props.row.status>
                    {{ props.row.status }}
                </div>
            </template>
            <template slot="action" slot-scope="props">
                <div class="c-pointer">
                    <!-- <router-link :to="{ name: 'viewPrimaryTrip' }">View Details</router-link>-->
                    <a class="fa fa-eye" role="button" v-on:click.stop="action(props.row)"></a>
                </div>
            </template>
        </v-server-table>
    </div>
</section>
</template>

<script>
import {
    USER_ROLES
} from "../../../config";
import {
    Event
} from "vue-tables-2";
import moment from "moment";
import {
    mapState
} from "vuex";
import {
    eventBus,
    primarytripService
} from "../../../services";
import dateFormatter from "../../utilities/dateFormate";
import {
    fa
} from "faker/lib/locales";
export default {
    name: "Trip",
    data() {
        return {
            disabledAfter: null,
            show: false,
            showw: false,
            status: [{
                    name: "Complete",
                    value: "complete"
                },
                {
                    name: "Pending",
                    value: "pending"
                },
                {
                    name: "Ongoing",
                    value: "ongoing"
                },
                {
                    name: "Upcoming",
                    value: "upcoming"
                },
            ],
            filters: {
                city: "",
                startLocation: "",
                endLocation: "",
                status: "",
                driver: "",
            },
            date: {
                startDate: "",
                endDate: "",
            },
            page: null,
            limit: null,
            loading: null,
            primaryTripTable: null,
            parameters: {},
            statusValue: "",
            endDateIso: "",
            startDateIso: "",
            noResult: true,
            adminCheck: {},
            cityList: [],
            startList: [],
            statusList: [],
            endList: [],
            startLocationList: [],
            endLocationList: [],
            driver_name: [],
            cityIdForDateFilter: "",
            startLocForDateFilter: "",
            endLocForDateFilter: "",
            count: null,
            count1: 0,
            cityFilterCount: 0,
            zoneFilterCount: 0,
            statusFilterCount: 0,
            driverFilterCount: 0,
            sDateFilterCount: 0,
            eDateFilterCount: 0,
            columns: [
                "areaName",
                "driver",
                "helper",
                "vehicle",
                // "collectionwaste",
                "status",
                "scheduleTime",
                "action",
            ],
            options: {
                highlightMatches: true,
                sortable: [],
                headings: {
                    cityName: "City",
                    areaName: "Zone",
                    // divisionward: 'Divison / Ward', //[division/ward]
                    driver: "Driver Name",
                    helper: "Helper Name",
                    vehicle: "Vehicle",
                    // collectionwaste: "Total Waste [KG]",
                    status: "Status",
                    scheduleTime: "Trip Schedule",
                    action: "Action",
                },
                templates: {
                    scheduleTime(row, query) {
                        return dateFormatter(query.scheduleTime);
                        // return moment(query.scheduleTime).format("DD-MM-YYYY");
                    },
                },
                perPage: 10,
                sortable: [
                    "cityName",
                    "areaName",
                    "driver",
                    "helper",
                    "vehicle",
                    // "collectionwaste",
                    "status",
                    "scheduleTime",
                ],
                requestFunction: (request) => {
                    this.parameters.page = request.page;
                    this.parameters.limit = request.limit;
                    this.page = request.page;
                    this.limit = request.limit;
                    if (this.startDateIso && this.endDateIso) {
                        this.parameters.startDate = this.startDateIso;
                        this.parameters.endDate = this.endDateIso;
                    } else {
                        delete this.parameters.startDate;
                        delete this.parameters.endDate;
                    }
                    if (request.orderBy) {
                        if (request.orderBy == "cityName") {
                            this.parameters.sortBy = "cityId.cityName";
                        } else if (request.orderBy == "areaName") {
                            this.parameters.sortBy = "caId.areaName";
                        } else if (request.orderBy == "divisionward") {
                            this.parameters.sortBy = "cdId.cdName";
                        } else if (request.orderBy == "endLocation") {
                            this.parameters.sortBy = "endLoc.plantName";
                        } else if (request.orderBy == "driver") {
                            this.parameters.sortBy = "driverId.firstName";
                        } else if (request.orderBy == "helper") {
                            this.parameters.sortBy = "helperId.firstName";
                        } else if (request.orderBy == "vehicle") {
                            this.parameters.sortBy = "vehicleId.vNumber";
                        } else if (request.orderBy == "status") {
                            this.parameters.sortBy = "tripStatus";
                        } else if (request.orderBy == "waste") {
                            this.parameters.sortBy = "totalWeight";
                        } else {
                            this.parameters.sortBy = request.orderBy;
                        }
                        if (request.ascending == 1) {
                            this.parameters.sortOrder = "asc";
                        } else {
                            this.parameters.sortOrder = "dsc";
                        }
                    }

                    if (request.query) {
                        // if(request.query.length < 3) return;
                        this.parameters.searchString = request.query.trim();
                    } else {
                        delete this.parameters.searchString;
                    }
                    if(this.count === 0 && this.count1 === 0) {
                        this.count = null;
                        this.count1 = null;
                    }
                    this.loading = true;
                    return primarytripService.getList(this.parameters).catch((error) => {
                        console.error("trip.requestFunction-error:", error);
                        this.$snotify.error("Get Trip", "Error!");
                    });
                },
                responseAdapter: (response) => {
                    this.loading = false;
                    let dataResp = [];
                    response.data.primaryTripData.forEach((element) => {
                        let finalData = element;
                        finalData["cityName"] = element.cityId ? element.cityId.cityName : '--';
                        finalData["areaName"] = element.caId ? element.caId.areaName : '--';
                        finalData["endLocation"] = element.endLoc ?
                            element.endLoc.plantName :
                            "--";
                        finalData["startLocation"] = element.startLoc ?
                            element.startLoc.plantName :
                            "--";
                        // finalData["divisionward"] = element.cdId.map(el => el.cdName).join(', ');
                        finalData["collectionwaste"] = "--";
                        finalData["driver"] = element.driverId ? element.driverId.firstName + " " + element.driverId.lastName : "--";
                        finalData["helper"] = element.helperId ? element.helperId.firstName + " " + element.helperId.lastName : "--";
                        finalData["vehicle"] = element.vehicleId ? element.vehicleId.vNumber : "--";
                        finalData["status"] =
                            element.tripStatus.charAt(0).toUpperCase() +
                            element.tripStatus.slice(1);
                        dataResp.push(finalData);
                    });
                    return {
                        data: dataResp,
                        count: response.data.count || dataResp.length,
                    };
                },
                uniqueKey: "_id",
            },
        };
    },
    computed: {
        addButtonClass() {
            if (this.primaryTripTable) {
                return this.primaryTripTable.count > this.primaryTripTable.limit ||
                    this.primaryTripTable.limit > 10 ?
                    "shift-add-left" :
                    "add-item";
            } else {
                return "add-item";
            }
        },
        ...mapState({
            user: (state) => state.auth.user,
        }),
    },
    methods: {
        clearFilter() {
            
            this.count = null;
            this.count1 = 0;
            this.cityFilterCount = 0;
            this.zoneFilterCount = 0;
            this.statusFilterCount = 0;
            this.driverFilterCount = 0;
            this.sDateFilterCount = 0;
            this.eDateFilterCount = 0;
            this.startDateIso = "";
            this.endDateIso = "";
            if( this.adminCheck === 'superAdmin') {
                this.driver_name = [];
                this.startLocationList = [];
            }    
            this.filters = {
                startLocation: "",
                endLocation: "",
                status: "",
                driver: "",
            };
           
            this.date = {
                startDate: "",
                endDate: "",
            };
       
            this.parameters.startLoc = "";
            this.parameters.endLoc = "";
            this.parameters.tripStatus = "";
            this.parameters.driverId = "";
      
            // this.startLocationList = [];
            this.endLocationList = [];
            this.$refs.primaryTripTable.refresh();
        },
        // startDate() {
            // const eventData = this.date.startDate.split("-");
            // const startDates = eventData[2] + "-" + eventData[1] + "-" + eventData[0];
            // this.startDateIso = new Date(startDates).toISOString();

        //     if (this.date.startDate != "" && this.date.endDate != "") {
        //         if(this.date.startDate > this.date.endDate){

        //             this.date.endDate = ""
        //             this.endDateIso = "";
        //             this.$refs.primaryTripTable.refresh();
        //         }
        //         this.getListByDate();
        //     } else {
        //         this.$refs.primaryTripTable.refresh();
        //     }
        // },
        // endDate() {
        //     if (this.date.startDate != "" && this.date.endDate != "") {                
        //         const eventData = this.date.endDate.split("-");
        //         const endDate = eventData[2] + "-" + eventData[1] + "-" + eventData[0];
        //         this.endDateIso = new Date(endDate).toISOString();                 
        //         this.getListByDate();
        //     } else {
        //         this.$refs.primaryTripTable.refresh();
        //     }
        // },
        startDate() {
            if(this.date.startDate && this.date.endDate === '' && this.sDateFilterCount === 0){
                this.count += 1;
                this.count1 += 1;
                this.sDateFilterCount = 1;
            }      
            if(this.date.startDate === "" && this.date.endDate){
                this.count -= 2;
                this.count1 -= 2;
                this.sDateFilterCount = 0;
            } 
            if(this.date.startDate === "" && this.date.endDate === ""){
                this.count -= 1;
                this.count1 -= 1;
                this.sDateFilterCount = 0;
            } 
            this.updateDates();
        },

        endDate() { 
            if(this.date.endDate && this.eDateFilterCount === 0){
                this.count += 1;
                this.count1 += 1;
                this.eDateFilterCount = 1;
            }      
            if(this.date.endDate === ''){
                this.count -= 1;
                this.count1 -= 1;
                this.eDateFilterCount = 1;
            } 
            this.updateDates();
        },

        updateDates() {           
            if(this.date.startDate != null && this.date.endDate == ''){
                this.startDateIso = new Date(this.formatDate(this.date.startDate)).toISOString();
                this.endDateIso = new Date(this.formatDate(this.date.endDate)).toISOString();
            }
            if (this.date.startDate && this.date.endDate) {
                const startDate = this.formatDate(this.date.startDate);
                const endDate = this.formatDate(this.date.endDate);

                if (startDate > endDate) {
                    this.clearEndDate();
                } else {
                    this.setIsoDates();
                    this.getListByDate();
                    return;
                }
            }

            this.clearDates();
            this.$refs.primaryTripTable.refresh();
        },

        formatDate(dateString) {
            const [year, month, day] = dateString.split("-");
            return `${day}-${month}-${year}`;
        },

        setIsoDates() {
            this.startDateIso = new Date(this.formatDate(this.date.startDate)).toISOString();
            this.endDateIso = new Date(this.formatDate(this.date.endDate)).toISOString();
        },

        clearEndDate() {
            this.date.endDate = "";
            this.endDateIso = "";
        },

        clearDates() {
            this.clearEndDate();
            this.startDateIso = "";
        },

        dateValidationClear(value) {
            if (value.length == 0) {
                this.endDateIso = ''
            }
        },
        getListByDate() {
            if (this.cityIdForDateFilter != "") {
                this.parameters.cityIds = this.cityIdForDateFilter;
            }
            if (this.startLocForDateFilter != "") {
                this.parameters.startLoc = this.startLocForDateFilter;
            }
            if (this.endLocForDateFilter != "") {
                this.parameters.endLoc = this.endLocForDateFilter;
            }
            this.parameters.page = this.page;
            this.parameters.limit = this.limit;
            this.parameters.startDate = this.startDateIso;
            this.parameters.endDate = this.endDateIso;
            this.loading = false;
            return primarytripService
                .getListDate(this.parameters)
                .then((response) => {
                    let count = response.data.count;
                    this.$refs.primaryTripTable.data = [];
                    this.loading = false;
                    let dataResp = [];
                    response.data.primaryTripData.forEach((element) => {
                        let finalData = element;
                        finalData["cityName"] = element.cityId ? element.cityId.cityName : '--';
                        finalData["areaName"] = element.caId ? element.caId.areaName : '--';
                        finalData["endLocation"] = element.endLoc ?
                            element.endLoc.plantName :
                            "--";
                        finalData["startLocation"] = element.startLoc ?
                            element.startLoc.plantName :
                            "--";
                        // finalData["divisionward"] = element.cdId.map(el => el.cdName).join(', ');
                        finalData["collectionwaste"] = "--";
                        finalData["driver"] = element.driverId ? element.driverId.firstName + " " + element.driverId.lastName : "--";
                        finalData["helper"] = element.helperId ? element.helperId.firstName + " " + element.helperId.lastName : "--";
                        finalData["vehicle"] = element.vehicleId ? element.vehicleId.vNumber : "--";
                        finalData["status"] =
                            element.tripStatus.charAt(0).toUpperCase() +
                            element.tripStatus.slice(1);
                        dataResp.push(finalData);
                    });
                    // this.dataPrimaryTrip = dataResp

                    this.$refs.primaryTripTable.data = dataResp;
                    this.$refs.primaryTripTable.count = count || dataResp.length;
                })
                .catch((error) => {
                    this.$snotify.error("Get Primary Trip list failed", "Error!");
                });
        },

        clearStatus() {
            delete this.parameters["status"];
            this.statusValue = "";
            this.$refs.primaryTripTable.refresh();
        },
        UpdateDestination(row) {
            if (row.status == "ongoing") {
                this.$router.push({
                    name: "UpdateDestination",
                    params: {
                        _id: row._id,
                    },
                    props: row,
                });
            }
        },
        edit(data) {
            if (data.row.status == "ongoing" || data.row.status == "completed") {
                this.$router.push({
                    name: "TripActivity",
                    params: {
                        _id: data.row._id,
                    },
                    props: data.row,
                });
            } else if (data.row.status == "scheduled") {
                this.$router.push({
                    name: "TripDetail",
                    params: {
                        _id: data.row._id,
                    },
                    props: data.row,
                });
            }
        },
        action(row) {
            this.$router.replace({
                name: "viewPrimaryTrip",
                params: {
                    _id: row._id,
                },
                props: row,
            });
        },
        onLoaded() {
            this.primaryTripTable = this.$refs.primaryTripTable;
        },

        getCityList() {
            const params = {};
            this.cityList = [];
            let cities = [];
            this.$cityRepository
                .collectionCitysList(params)
                .then((res) => {
                    this.loading = false;
                    res.data.response.forEach((element) => {
                        if (element.status === true) {
                            cities.push({
                                name: element.cityName.length > 20 ?
                                    element.cityName.slice(0, 20) + "..." : element.cityName,
                                value: element._id,
                            });
                        }
                    });
                    cities.sort((item1, item2) => {
                        return item1.name.toLowerCase() < item2.name.toLowerCase() ? -1 : 1;
                    });
                    this.cityList = cities;
                })
                .catch((error) => {
                    this.loading = false;
                    console.error("cities.requestFunction-error:", error);
                    this.$snotify.error("Get cities list failed", "Error!");
                });
        },
        onCheckedDriver(option){
            if(this.driverFilterCount === 0){
                this.driverFilterCount = 1;
                this.count += 1;
            }
            this.filters.driver = option;            
            this.parameters.driverId = option.value;
            this.$refs.primaryTripTable.refresh();
        },
        onRemoveDriver(option){
            if(this.driverFilterCount === 1){
                this.driverFilterCount = 0;
                this.count -= 1;
            }
            this.filters.driver = "";
            this.parameters.driverId = "";
            this.$refs.primaryTripTable.refresh();
        },
        onCheckedStatus(option){
            if(this.statusFilterCount === 0){
                this.statusFilterCount = 1;
                this.count += 1;
                this.count1 += 1;
            }
            if(this.$route.params.tripStatus === 'complete'){
                const option = {
                    name: 'Complete',
                    value: [{
                        name: 'Complete',
                        value: 'complete'
                    }]
                };
                this.filters.status = option;
                this.parameters.tripStatus = ['complete'];
            } else if(this.$route.params.tripStatus === 'ongoing') {
                const option = {
                    name: 'Ongoing',
                    value: [{
                        name: 'Ongoing',
                        value: 'ongoing'
                    }]
                };
                this.filters.status = option;
                this.parameters.tripStatus = ['ongoing'];
            } else if(this.$route.params.tripStatus === 'scheduled') {
                const option = {
                    name: 'Pending',
                    value: [{
                        name: 'Pending',
                        value: 'pending'
                    },
                    {
                        name: 'Upcoming',
                         value: 'upcoming'
                    }]
                };
                this.filters.status = option;                
                this.parameters.tripStatus = ['pending','upcoming'];
            } else {
                this.filters.status = option;
                this.statusList.push(option.value);
                let list = this.statusList.join(",");
                this.parameters.tripStatus = list;
                this.$refs.primaryTripTable.refresh();
            }
        },
        onRemoveStatus(option){
            this.statusList = this.statusList.filter((el) => el != option.value);
            let list = this.statusList.join(",");
            if(this.statusFilterCount === 1 && list === ''){
                this.statusFilterCount = 0;
                this.count -= 1;
                this.count1 -= 1;
            }
            this.parameters.tripStatus = list;
            this.$refs.primaryTripTable.refresh();
        },
        onCheckedCity(option) { 
            // if(this.cityFilterCount === 1){
            //     this.count = 1;
            //     if(this.count1){
            //         this.count += this.count1;
            //     }
            //     this.zoneFilterCount = 0;
            //     this.driverFilterCount = 0;
            // }
            // if(this.cityFilterCount === 0){
            //     this.cityFilterCount = 1;
            //     this.count += 1;
            // }
            this.startList = [];
            this.statusList = [];
            this.startDateIso = "";
            this.endDateIso = "";
            this.filters.startLocation = "";
            this.filters.driver = "";
            this.filters.endLocation = "";
            this.parameters.startLoc = "";
            this.parameters.endLoc = "";
            this.filters.city = option;
            let cityId = option.value;
            this.cityIdForDateFilter = cityId
            this.getArea(cityId);
            this.getDriverList(cityId);
            this.getEndLocations(cityId);
            this.parameters.cityIds = cityId;
            if(this.$refs.primaryTripTable.refresh){
                this.$refs.primaryTripTable.refresh();
            }
            
        },
        onRemoveCity(option) {
            this.cityFilterCount = 0;
            this.zoneFilterCount = 0;
            this.driverFilterCount = 0;
            this.count = this.count1;
            this.parameters.startLoc = "";
            this.filters.startLocation = "";
            this.filters.driver = "";
            this.driver_name = []
            this.startLocationList = [];
            let cityId = option.value;
            this.parameters.cityIds = "";
            this.parameters.driverId = "";
            this.cityIdForDateFilter = "";
            this.$refs.primaryTripTable.refresh();
        },
        getDriverList(id) {
            let driver_nameList = [];
            this.driver_name = [];
            return primarytripService
                .driverList(id)
                .then((res) => {
                    res.data.response.forEach((element) => {
                        if (element.status == true) {
                            driver_nameList.push({
                                name: element.firstName + " " + element.lastName,
                                value: element._id,
                            });
                        }
                    });
                    driver_nameList.sort((item1, item2) => {
                        return item1.name.toLowerCase() < item2.name.toLowerCase() ? -1 : 1;
                    });
                    this.driver_name = driver_nameList;
                    
                })
                .catch((error) => {
                    this.loading = false;
                    console.error("Driver.requestFunction-error:", error);
                    this.$snotify.error("Driver list failed", "Error!");
                });
        },
        getArea(id) {
            this.loading = true;
            this.startLocationList = [];
            let arealist = [];
            return primarytripService
                .getWasteCollectionAreaList(id)
                .then((res) => {
                    this.loading = false;
                    res.data.response.forEach((element) => {
                        arealist.push({
                            name: element.areaName.length > 20 ?
                                element.areaName.slice(0, 20) + "..." : element.areaName,
                            value: element._id,
                        });
                    });
                    arealist.sort((item1, item2) => {
                        return item1.name.toLowerCase() < item2.name.toLowerCase() ? -1 : 1;
                    });
                    this.startLocationList = arealist;
                    this.noResult = this.startLocationList.length > 0 ? false : true;
                })
                .catch((error) => {
                    this.loading = false;
                    console.error(
                        "getWasteCollectionAreaList.requestFunction-error:",
                        error
                    );
                    this.$snotify.error(
                        "Get Ward Details List  failed",
                        "Error!"
                    );
                });
        },

        getEndLocations(id) {
            this.endLocationList = [];
            let endlocationSort = [];
            let locations = [];
            return primarytripService
                .getEndLocations(id)
                .then((res) => {
                    this.loading = false;
                    
                    res.data.response.forEach((element) => {
                       const name = element.plantName ? (element.plantName.length > 20 ? element.plantName.slice(0, 20) + "..." : element.plantName) : '';
                        locations.push({
                            name: name + " - " + element.name,
                            _id: element._id,
                        });
                    });
                    endlocationSort = locations;
                    endlocationSort.sort((item1, item2) => {
                        return item1.name.toLowerCase() < item2.name.toLowerCase() ? -1 : 1;
                    });
                    this.endLocationList = endlocationSort;
                })
                .catch((error) => {
                    this.loading = false;
                    console.error("getLineAndTowerByDivisions.getAreaById-error:", error);
                });
        },
        getStartLocation(option) {
            if(this.zoneFilterCount === 0){
                this.zoneFilterCount = 1;
                this.count += 1;
            }
            this.filters.startLocation = option;
            this.startList.push(option.value);
            let list = this.startList.join(",");
            this.parameters.startLoc = list;
            this.startLocForDateFilter = list
            this.$refs.primaryTripTable.refresh();
        },
        onRemoveSL(option) {
            if (this.$store.state.auth.user.role.key != "superAdmin") {
                this.parameters.startLoc = '';
            }
            this.startList = this.startList.filter((el) => el != option.value);
            let list = this.startList.join(",");
            this.parameters.startLoc = list;
            this.startLocForDateFilter = list
            if(this.zoneFilterCount === 1 && list === ""){
                this.zoneFilterCount = 0;
                this.count -= 1;
            }
            this.$refs.primaryTripTable.refresh();
        },
        getEndLocation(option) {
            this.filters.endLocation = option;
            this.endList.push(option._id);
            let list = this.endList.join(",");
            this.parameters.endLoc = list;
            this.endLocForDateFilter = list
            this.$refs.primaryTripTable.refresh();
        },
        onRemoveEL(option) {
            this.endList = this.endList.filter((el) => el != option._id);
            let list = this.endList.join(",");
            this.parameters.endLoc = list;
            this.endLocForDateFilter = list
            this.$refs.primaryTripTable.refresh();
        },
    },
    mounted() {
        eventBus.$on('cityIdChanged', this.onCheckedCity);
        if (this.$store.state.auth.user.role.key === "superAdmin") {
            this.columns.unshift("cityName");
        }
        document.addEventListener("click", (event) => {
                if (
                    event.target.closest(".close-date-picker") &&
                    !event.target.matches(".gradientbt") &&
                    !event.target.closest(".datedrop_boxs") &&
                    !event.target.closest(".datemodify")
                ) {
                    this.show = false;
                }
            }),
            this.getCityList();
    },
    beforeDestroy() {
        eventBus.$off('cityIdChanged', this.onCheckedCity);
    },
    created() {
        if (this.$store.state.auth.user.role.key !== "cityAdmin" || this.$store.state.auth.user.role.key !== "subCityAdmin") {
            this.parameters.cityIds = this.$store.state.auth.cityId.value
            this.getArea(this.parameters.cityIds);
            this.getDriverList(this.parameters.cityIds);
            this.getEndLocations(this.parameters.cityIds);
        }
        if(this.$route.params.tripStatus){
            this.onCheckedStatus();
        }
        this.adminCheck = this.$store.state.auth.user.role.key;
        let cityIdGetArea = this.$store.state.auth.user.cityId && this.$store.state.auth.user.cityId._id ? this.$store.state.auth.user.cityId._id : "";
        if (this.adminCheck !== 'superAdmin') {
            console.log("this.adminCheck",this.adminCheck)
            this.getArea(cityIdGetArea);
            this.getDriverList(cityIdGetArea);
        }

        this.filters = {
            ...this.filters,
            city:{
                ...this.filters.city,
                value:this.$route.params.cityIds
            }
        }
        if (this.$route.params.cityIds && this.$route.params.cityIds.value) {
            this.parameters.cityIds = this.filters.city.value.value;
            // if (this.cityFilterCount === 0) {
            //     this.cityFilterCount = 1;
            //     this.count += 1;
            // }
            if (this.$refs.primaryTripTable && this.$refs.primaryTripTable.refresh) {
                this.$refs.primaryTripTable.refresh();
            }
        }

    },
};
</script>

<style scoped>
.sorting {
    position: absolute;
    left: 319px;
    z-index: 1000;
    width: 225px;
    margin-left: 250px;
}

.box-body {
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.inline {
    background-color: rgba(255, 132, 78);
    color: white;
}

.addnew {
    background-image: linear-gradient(to right,
            rgba(38, 153, 251),
            rgba(146, 205, 255));
    color: white;
}

.main_select_wrp_relative .modal-dialog {
    width: 57% !important;
}

.main_select_wrp_relative {
    position: absolute;
    right: 30%;
    top: 25px;
}

.filter_wrpp button svg {
    width: 20px;
    height: 20px;
    margin-right: 10px;
}

.filter_wrpp button {
    display: flex;
    align-items: center;
    margin-right: 5px;
}

.filter_wrpp button:hover {
    background: #0f6940;
    color: #fff;
}

.main_select_wrp_relative+.add-item {
    display: flex;
}

.select_date_wrp .datedrop_boxs {
    position: static;
    width: 100%;
    padding: 0px;
    box-shadow: none;
    border: transparent;
}

.select_date_wrp {
    margin-top: 20px;
}

.select_date_wrp .datedrop_boxs_wrp {
    float: initial;
    background: transparent;
    margin-right: 0;
}

/* .dates_left label {
    color: #000
} */

.dates_left {
    flex: 0 0 32.5%;
    margin-right: 10px;
}

.selectwca_wrp .multiselect__tags-wrap{
    background-color: transparent;
    width: 186px;
}
.selectwca_wrp .multiselect__tag {
    padding: 4px 15px 4px 10px;
}
.selectwca_wrp .multiselect__tags {
    min-height: 45px
}



@media(max-width:767px) {
    .main_select_wrp_relative .modal-dialog {
        width: 94% !important;
    }

    .primary_trip_res {
        margin-bottom: 10px;
    }
}
</style>



// WEBPACK FOOTER //
// primarytrip.vue?5a11ddbb